import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";

export class SeekCard extends Phaser.GameObjects.Sprite {
    id: number;
    name: string;
    position: Phaser.Geom.Point;

    constructor(scene: Phaser.Scene, ob: TiledGameObject) {
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "card" + ob.properties["id"]);

        this.id = ob.properties["id"] as number;
        this.name = ob.name;
        this.position = new Phaser.Geom.Point(this.x, this.y);

        this.setDepth(2);
        this.setDisplaySize(ob.width, ob.height);

        this.setInteractive();
        this.scene.input.setDraggable(this);

        this.scene.add.existing(this);
    }
}

export class SeekItem extends Phaser.GameObjects.Zone {
    id: number;
    name: string;
    found: boolean;
    overlay: Phaser.GameObjects.Image;
    constructor(scene: Phaser.Scene, ob: TiledGameObject) {
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, ob.width, ob.height);

        this.id = ob.properties["id"] as number;
        this.name = ob.name;
        this.found = false;

        this.setDepth(2);

        this.setRectangleDropZone(this.width, this.height);

        this.scene.add.existing(this);
    }
}



// WEBPACK FOOTER //
// ./src/games/SeekAndFindGame/objects/SeekItem.ts